export type FeatureFlags = "";
export type FeatureFlagConfig = Record<FeatureFlags, boolean>;

export const enabledInsightSizes = [
  "mpu",
  "large-responsive",
  "billboard",
  "small-responsive"
];

export const enabledParlaySizes = ["mpu", "large-responsive", "billboard"];
